module.exports = __webpack_public_path__ + "static/python-static-5e086a42e8a2f2b5d67f704b1f293c02.png";